import { sendStatistics } from '../spenttime/measurement';
import { clearTimers } from './userActivityEvents';
import { spenttimeDebug as debug } from '../debug';
export var loginHandler = function (e) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var changes = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.changes;
    var isLoginChanged = changes.some(function (val) { return val === 'login'; });
    if (!isLoginChanged) {
        return;
    }
    var newUid = (_e = (_d = (_c = (_b = e.detail) === null || _b === void 0 ? void 0 : _b.newIdentities) === null || _c === void 0 ? void 0 : _c.login) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.uid;
    var oldUid = (_j = (_h = (_g = (_f = e.detail) === null || _f === void 0 ? void 0 : _f.oldIdentities) === null || _g === void 0 ? void 0 : _g.login) === null || _h === void 0 ? void 0 : _h.value) === null || _j === void 0 ? void 0 : _j.uid;
    debug("IS: New UID: ".concat(newUid, ", Old UID: ").concat(oldUid, " "));
    if (newUid !== oldUid) {
        debug('[event] User has been logged in a different account');
        clearTimers();
        sendStatistics();
    }
};
export var addUserLoginListener = function () {
    debug('[event] User Login event listeners have been added');
    window.addEventListener('szn:identities:beforeupdate', loginHandler);
};
export var removeUserLoginListener = function () {
    debug('[event] User Login event listeners have been removed');
    window.removeEventListener('szn:identities:beforeupdate', loginHandler);
};
